module.exports = __webpack_public_path__ + "assets/img/36_513_big.723899e9.jpg";